<template>
  <button
      class="common-button"
      :class="[type, size, { disabled }]"
      :disabled="disabled || loading"
      @click="onClick"
  >
    <i v-if="icon" :class="icon" class="button-icon"></i>
    <slot v-if="!loading"></slot>
    <loading :width=22 :height=22 color="white" :active="loading" :is-full-page="false" loader="dots"/>
  </button>
</template>

<script>
import Loading from 'vue-loading-overlay';
import '@/components/buttons/vue-loading.css';
export default {
  name: "CommonButton",
  components: {Loading},
  props: {
    type: {
      type: String,
      default: "primary",
      validator: value => ["primary", "secondary", "danger", "warning", "outline", "outline-danger"].includes(value)
    },
    size: {
      type: String,
      default: "medium",
      validator: value => ["small", "medium", "large"].includes(value)
    },
    icon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  // mounted() {
  //   const loadingDivs = document.querySelectorAll('.has-loading');
  //   loadingDivs.forEach(div => {
  //     const background = div.querySelector('.vld-background');
  //     if (background) {
  //       background.remove();
  //     }
  //   });
  // },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.common-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 14px;
  padding: 0 16px;
  transition: all 0.3s ease;
  min-width: 100px;
  div.vld-overlay {
    position: relative;
  }
  &.primary {
    background-color: #409eff;
    color: white;

    &:hover {
      background-color: #66b1ff;
    }
  }

  &.secondary {
    background-color: #909399;
    color: white;

    &:hover {
      background-color: #a6a9ad;
    }
  }

  &.danger {
    background-color: #f56c6c;
    color: white;

    &:hover {
      background-color: #f78989;
    }
  }

  &.warning {
    background-color: #e6a23c;
    color: white;

    &:hover {
      background-color: #ebb563;
    }
  }

  &.small {
    height: 28px;
    font-size: 12px;
  }

  &.medium {
    height: 32px;
  }

  &.large {
    height: 40px;
    font-size: 16px;
  }

  &.disabled {
    opacity: 0.7;
    cursor: not-allowed;

    &:hover {
      opacity: 0.7;
    }
  }
  &.outline {
    background-color: transparent;
    color: #4c4c4c;
    border: 1.5px solid #4c4c4c;
    box-shadow: none;
  }
  &.outline-danger {
    background-color: transparent;
    color: #f56c6c;
    border: 1.5px solid #f56c6c;
    box-shadow: none;
  }


  .button-icon {
    margin-right: 8px;
  }
}
</style>
